'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import detectPassiveEvents from '../../utils/detectPassiveEvents';

export default class ScrollUp extends React.Component {
  constructor (props) {
    super(props);

    this.state = {show: false};

    this.data = {
      startValue: 0,
      currentTime: 0,
      startTime: null,
      rafId: null
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.scrollStep = this.scrollStep.bind(this);
    this.stopScrolling = this.stopScrolling.bind(this);

    this.easeOutCubic = function (currentTime, beginValue, endValue, totalDuration) {
      const c = endValue - beginValue;
      return c * ((currentTime = currentTime / totalDuration - 1) * currentTime * currentTime + 1) + beginValue;
    };
  }

  shouldComponentUpdate (nextProps, nextState) {
    return nextState.show !== this.state.show;
  }

  componentDidMount () {
    this.handleScroll();

    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('wheel', this.stopScrolling, detectPassiveEvents.hasSupport ? {passive: true} : false);
    window.addEventListener('touchstart', this.stopScrolling, detectPassiveEvents.hasSupport ? {passive: true} : false);
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('wheel', this.stopScrolling, false);
    window.removeEventListener('touchstart', this.stopScrolling, false);
  }

  /**
   * Оценивает показать/скрыть компонент, зависит от новой позиции
   */
  handleScroll () {
    if (window.pageYOffset > this.props.showUnder) {
      if (!this.state.show) {
        this.setState({show: true});
      }
    } else {
      if (this.state.show) {
        this.setState({show: false});
      }
    }
  }

  handleClick () {
    this.stopScrolling();
    this.data.startValue = window.pageYOffset;
    this.data.currentTime = 0;
    this.data.startTime = null;
    this.data.rafId = window.requestAnimationFrame(this.scrollStep);
  }

  /**
   * Высчитывает новую позицию
   * и скролит экран на новую позицию или останавливает анимацию
   * @param timestamp
   */
  scrollStep (timestamp) {
    if (!this.data.startTime) {
      this.data.startTime = timestamp;
    }

    this.data.currentTime = timestamp - this.data.startTime;

    let position = this.easeOutCubic(
      this.data.currentTime,
      this.data.startValue,
      this.props.topPosition,
      this.props.duration
    );

    if (window.pageYOffset <= this.props.topPosition) {
      this.stopScrolling();
    } else {
      window.scrollTo(window.pageYOffset, position);
      this.data.rafId = window.requestAnimationFrame(this.scrollStep);
    }
  }

  stopScrolling () {
    window.cancelAnimationFrame(this.data.rafId);
  }

  render () {
    const style = {
      opacity: (this.state.show ? 1 : 0),
      visibility: (this.state.show ? 'visible' : 'hidden')
    };

    return (
      <div className='page-scroll-up' style={style} onClick={this.handleClick}>
        <i className='icon-arrow-up' />
      </div>
    );
  }
}

ScrollUp.propTypes = {
  showUnder: PropTypes.number.isRequired, // показывать кнопку ниже этой позиции
  duration: PropTypes.number,             // seconds,
  topPosition: PropTypes.number
};

ScrollUp.defaultProps = {
  duration: 250,
  topPosition: 0
};



// WEBPACK FOOTER //
// ./src/ui/Controls/ScrollUp.jsx